import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm'
import ProjectsSchema from 'schemas/organizationInfo.schema.json'
import { updateProjectInfo } from 'utils/DetailsUtils'
import { useFormContext } from 'hooks/useFormContext'
import SkeletonForm from 'components/Shared/SkeletonForm'
import { useAppContext } from 'hooks/useAppContext';
import { useCanDoAction } from 'hooks/useCanDoAction';

const Organization = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {
    const formContext = useFormContext()
    const { selectedProject } = useAppContext();
    const canEdit = useCanDoAction('Projects', 'update');
    useEffect(() => {
        !formContext.schema && formContext.updateSchema(ProjectsSchema)
    })

    const onSubmit = async (values) => {
        let result
        if (CRUDType === "UPDATE") {
            result = await updateProjectInfo(values, selectedProject)
            setTimeout(callback, 1000)
        }
        return result
    }
    return <div style={{ padding: '15px' }}>

        {formContext.ready ?
            withExtension(DynamicForm, { schema: ProjectsSchema, orientation: "Horizontal", onSubmit, defaultValues,
            disabledProperties, hiddenProperties, definitions: formContext.definitions, readOnly: true, readOnlyEdit: canEdit, title: true }) :
            <SkeletonForm />
        }
    </div>
}

Organization.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

Organization.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}

export default Organization